<template>
  <b-modal :id="`FormCategoria`"
           :ref="`FormCategoria`"
           no-close-on-backdrop
           no-close-on-esc
           class="FormCategoria"
           header-class="FormCategoria_header"
           body-class="FormCategoria_body"
           content-class="FormCategoria_content"
           size="xl"
           visible
           @hide="hide()">
    <template slot="modal-header">
      <div>
        <b class="ml-2">Categoria ou tipo de ato</b>
      </div>
    </template>
    <div class="row align-items-center p-2">
      <div class="col-8">
        <div class="row">
          <div class="col-4">
            <label for="tipo">Tipo de lançamento</label>
            <div class="row">
              <div class="col-6">
                <b-form-radio v-model="localData.tipo"
                              name="some-radios"
                              value="DESPESA"
                              @change="changeTipo">
                  Despesa
                </b-form-radio>
              </div>
              <div class="col-6 pl-4">
                <b-form-radio v-model="localData.tipo"
                              name="some-radios"
                              value="RECEITA"
                              @change="changeTipo">
                  Receita
                </b-form-radio>
              </div>
            </div>
          </div>
          <div v-if="localData.tipo === 'DESPESA'"
               class="col-8">
            <label for="nome">{{ localData.tipo === 'DESPESA' ? 'Descrição' : 'Tipo de ato' }}</label>
            <input id="nome"
                   v-model="localData.nome"
                   v-validate="'required'"
                   type="text"
                   name="nome"
                   class="form-control form-control-sm"
                   :class="{'is-invalid': errors.has('nome')}">
            <small class="invalid-feedback">{{ errors.first('nome') }}</small>
          </div>
        </div>
      </div>
    </div>

    <div v-if="localData.tipo === 'RECEITA'"
         class="row  align-items-center p-2">
      <div class="col-6">
        <label for="nome">{{ localData.tipo === 'DESPESA' ? 'Descrição' : 'Tipo de ato' }}</label>
        <input id="nome"
               v-model="localData.nome"
               v-validate="'required'"
               type="text"
               name="nome"
               class="form-control form-control-sm"
               :class="{'is-invalid': errors.has('nome')}">
        <small class="invalid-feedback">{{ errors.first('nome') }}</small>
      </div>
      <div class="col-6">
        <label for="ato">Ato</label>
        <input id="ato"
               v-model="localData.ato"
               type="text"
               class="form-control form-control-sm">
      </div>
    </div>
    <div class="row align-items-center p-2">
      <div class="col-1">
        <b-form-checkbox
          v-model="localData.ativo"
          :value="1"
          switch>
          Ativo
        </b-form-checkbox>
      </div>
      <div v-if="localData.tipo === 'RECEITA'"
           class="col-5">
        <b-form-checkbox
          v-model="localData.agrupar"
          :value="1"
          switch>
          Agrupar lançamentos deste ato na impressão
        </b-form-checkbox>
      </div>
    </div>
    <template slot="modal-footer"
              slot-scope="{ cancel }">
      <button class="btn btn-sm btn-light px-3"
              @click="cancel">
        Voltar
      </button>
      <button class="btn btn-secondary btn-sm"
              @click="propCategoria ? editarCategoria() : cadastrarCategoria()">
        {{ propCategoria ? 'Editar' : 'Adicionar' }}
      </button>
    </template>
  </b-modal>
</template>

<script>
  export default {
    name: 'FormCategoria',
    props: {
      propShowModal: { type: Boolean, default: false },
      propCategoria: { type: Object, default: null}
    },
    data () {
      return {
        localData: {
          tipo: 'DESPESA',
          agrupar: 0,
          nome: null,
          ato: null,
          ativo: 1,
        }
      }
    },
    mounted () {
      if (this.propCategoria) {
        this.localData = {...this.propCategoria}
      }
    },
    methods: {
      async cadastrarCategoria () {
        const valid = await this.$validator.validateAll()

        if (!valid) return

        const { nome } = this.localData

        if (nome && nome.toUpperCase().match('REGISTRO CIVIL')) {
          return displayMessage('error', 'Erro!', 'Categoria com nome inválido!')
        }

        this.$emit('cadastrar', this.localData)
      },
      async editarCategoria () {
        const valid = await this.$validator.validateAll()

        if (!valid) return

        const { nome } = this.localData

        if (nome && nome.toUpperCase().match('REGISTRO CIVIL')) {
          return displayMessage('error', 'Erro!', 'Categoria com nome inválido!')
        }

        const editado = {}

        Object.keys(this.propCategoria).forEach(key => {
          if (this.localData[key] !== this.propCategoria[key]) {
            editado[key] = this.localData[key]
          }
        })

        if (Object.values(editado).length) editado.categoria_id = this.localData.categoria_id

        this.$emit('editar', editado)
      },
      hide () {
        this.$emit('hide')
      },
      changeTipo (tipo) {
        if (this.propCategoria) {
          if (tipo === 'DESPESA') this.localData.ato = null
          return
        }

        this.localData = {
          ...this.localData,
          agrupar: 0,
          nome: null,
          ato: null,
          ativo: 1,
        }
      }
    }
  }
</script>

<style lang="scss">
  .FormCategoria {
    &_header {
      background: #074f7f;
      color: #fff;
      padding: 10px;
      font-size: 20px;
      font-weight: bold;
      border-radius: 0px;
    }

    &_content {
      border-radius: 0px;
    }

    &_body {
      padding: 5px 10px;
    }

    &_body label {
      font-size: 16px;
      font-weight: 500;
      color: #373a3c;
    }

    &_subtitle {
      border-bottom: 1px solid black ;
      margin: 10px 0px;
    }

    &_subtitle h1 {
      font-size: 18px;
      font-weight: 500;
      color: #262626;
    }
  }
</style>

